<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-unpaid-order-dialog-form">
    <table>
      <tr>
        <td colspan="2">
          <h3>{{ data.subscriptionName }}</h3>
        </td>
      </tr>
      <tr>
        <th>Order Total:</th>
        <td>{{ data.orderTotal | currency }}</td>
      </tr>
      <tr>
        <th>Previously Paid:</th>
        <td>{{ data.previouslyPaid | currency }}</td>
      </tr>
      <tr>
        <th>Total Due:</th>
        <td>{{ data.totalDue | currency }}</td>
      </tr>
      <tr>
        <td colspan="2">
          <h3>Payment Details</h3>
        </td>
      </tr>
    </table>
    <br />
    <mat-form-field>
      <mat-label>Amount Paid</mat-label>
      <input
        matInput
        name="data.amountPaid"
        [(ngModel)]="data.amountPaid"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Payment Date</mat-label>
      <input
        matInput
        name="data.paymentDate"
        [(ngModel)]="data.paymentDate"
      /> </mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Order
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
